"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchDayMax = exports.matchDayMin = exports.matchDay = void 0;
var date_fns_1 = require("date-fns");
function isDayAfter(day1, day2) {
    return date_fns_1.isAfter(day1, day2) && !date_fns_1.isSameDay(day1, day2);
}
function isDayBefore(day1, day2) {
    return date_fns_1.isBefore(day1, day2) && !date_fns_1.isSameDay(day1, day2);
}
function matchDate(day, matcher) {
    if (!(matcher instanceof Date))
        return false;
    return date_fns_1.isSameDay(day, matcher);
}
function matchDayInRange(day, matcher) {
    if (!('from' in matcher) || !('to' in matcher))
        return false;
    if (date_fns_1.differenceInDays(matcher.to, matcher.from) <= 0)
        return false;
    return date_fns_1.isWithinInterval(day, { start: matcher.from, end: matcher.to });
}
function matchDayBefore(day, matcher) {
    if ('after' in matcher || !('before' in matcher))
        return false;
    return isDayBefore(day, matcher.before);
}
function matchDayAfter(day, matcher) {
    if ('before' in matcher || !('after' in matcher))
        return false;
    return isDayAfter(day, matcher.after);
}
function matchDayBetween(day, matcher) {
    if (!('after' in matcher) || !('before' in matcher))
        return false;
    if (date_fns_1.differenceInDays(matcher.before, matcher.after) <= 0)
        return false;
    return isDayAfter(day, matcher.after) && isDayBefore(day, matcher.before);
}
function matchDayOfWeek(day, matcher) {
    if (!('daysOfWeek' in matcher))
        return false;
    return matcher.daysOfWeek.includes(day.getDay());
}
function matchFunction(day, matcher) {
    if (!(matcher instanceof Function))
        return false;
    return matcher(day);
}
/**
 * Return `true` if a day matches a day matcher.
 */
function matchDay(day, matcher) {
    if (!matcher || !day)
        return false;
    var matchers;
    if (Array.isArray(matcher)) {
        matchers = matcher;
    }
    else {
        matchers = [matcher];
    }
    return matchers.some(function (dayMatcher) {
        if (!dayMatcher)
            return false;
        return (matchDate(day, dayMatcher) ||
            matchDayInRange(day, dayMatcher) ||
            matchDayBefore(day, dayMatcher) ||
            matchDayAfter(day, dayMatcher) ||
            matchDayBetween(day, dayMatcher) ||
            matchDayOfWeek(day, dayMatcher) ||
            matchFunction(day, dayMatcher));
    });
}
exports.matchDay = matchDay;
/**
 * Return `true` if a day is match the "before" assertion (equivalent to "minimum")
 */
function matchDayMin(day, matcher) {
    if (!matcher)
        return false;
    var matchers;
    if (Array.isArray(matcher)) {
        matchers = matcher;
    }
    else {
        matchers = [matcher];
    }
    return matchers.some(function (dayMatcher) {
        if (!dayMatcher)
            return false;
        return (matchDayBefore(day, dayMatcher));
    });
}
exports.matchDayMin = matchDayMin;
/**
 * Return `true` if a day is match the "after" assertion (equivalent to "maximum")
 */
function matchDayMax(day, matcher) {
    if (!matcher)
        return false;
    var matchers;
    if (Array.isArray(matcher)) {
        matchers = matcher;
    }
    else {
        matchers = [matcher];
    }
    return matchers.some(function (dayMatcher) {
        if (!dayMatcher)
            return false;
        return (matchDayAfter(day, dayMatcher));
    });
}
exports.matchDayMax = matchDayMax;
